<template>
    <div id="item-container">
        <b-row>
            <b-col>
                <MdTitle
                    v-bind:Text="
                        this.editMode
                            ? $t('TestOrdersResultSetupL.EditSetup')
                            : $t('TestOrdersResultSetupL.AddSetup')
                    "
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12" v-if="false">
                <MdEdit
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="15"
                    v-model="objecResultObj.code"
                    v-bind:isReadOnly="isReadOnly || editMode"
                    v-bind:Id="'input_code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Description')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'description'"
                    v-bind:MaxLengthProp="100"
                    v-model="objecResultObj.name"
                    v-bind:isRequired="true"
                    v-bind:Id="'input_description'"
                >
                </MdEdit>
            </b-col>

            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Type')"
                    v-bind:Options="procTypeOptions"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:AllowEmpty="true"
                    v-bind:Model="objecResultObj.procType"
                    :Input="ChangeType"
                    :SortAlphabetical="true"
                    :UseTitleCase="true"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:ModelCode="objecResultObj.cptcode"
                    v-bind:ModelDescription="dcpt"
                    v-bind:Label="$t('Shared.CPT')"
                    v-bind:RefCode="'cpt'"
                    v-bind:Api="'cpts'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('Shared.CPT')"
                    :GetValues="onCodeConditionOk"
                    :InvalidFeedback="$t('rooms.cptRequired')"
                    :SearchFieldCode="'code'"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdLookupMultiple
                    v-bind:modelFilter="modelFilter"
                    v-bind:OptionParamList="ParamList"
                    v-bind:ModelCode="objecResultObj.diagCode"
                    v-bind:ModelDescription="ddiag"
                    v-bind:Label="$t('Shared.Diagnosis')"
                    v-bind:RefCode="'Diagnosis'"
                    v-bind:Api="'DiagnosisICD10Providers'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$t('Shared.Diagnosis')"
                    :GetValues="onCodeConditionOk"
                    :InvalidFeedback="$t('rooms.cptRequired')"
                    :SearchFieldCode="'code'"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.UnitPrice')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'unitPrice'"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'0.01'"
                    v-model="objecResultObj.unitPrice"
                    v-money-prefix
                    v-bind:Id="'input_unitPrice'"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('TestOrdersResultSetupL.LowR')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'LowRange'"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'0.01'"
                    v-model="objecResultObj.lowRange"
                    v-money-prefix
                    v-bind:Id="'input_lowRange'"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('TestOrdersResultSetupL.HighRange')"
                    v-bind:TypeProp="'number'"
                    v-bind:Name="'HighRange'"
                    v-bind:Min="'0'"
                    v-bind:StepProp="'0.01'"
                    v-model="objecResultObj.highRange"
                    v-money-prefix
                    v-bind:Id="'input_highRange'"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Unit')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Unit'"
                    v-model="objecResultObj.unit"
                    v-bind:Id="'input_unit'"
                    v-bind:MaxLengthProp="10"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="'Loinc'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'Loinc'"
                    v-model="objecResultObj.loincCode"
                    v-bind:Id="'input_loin'"
                    v-bind:MaxLengthProp="100"
                >
                </MdEdit>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit
                    v-bind:Label="'RxNorm'"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'RxNorm'"
                    v-model="objecResultObj.rxNorm"
                    v-bind:Id="'input_rx'"
                    v-bind:MaxLengthProp="15"
                >
                </MdEdit>
            </b-col>
            <b-col lg="6" md="6" sm="12">
                <MdEdit
                    v-bind:Label="$t('TestOrdersResultSetupL.LongD')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'longName'"
                    v-bind:MaxLengthProp="250"
                    v-model="objecResultObj.longName"
                    v-bind:Id="'input_longname'"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnBack'"
                v-bind:TextToolTip="$t('ePharmacyItemsReceived.BackToList')"
                v-on:click="goBack"
                v-bind:ClassProp="'mx-2 btn-login'"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="this.isReadOnly ? 'primary mx-2' : 'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly="this.isReadOnly"
                v-bind:Name="'btn_save_inventory_item'"
            />
        </div>
    </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import { EventBus } from '@/event-bus.js';
import TestOrderResultSetupService from '@/services/testorderresultsetup.service';
import CPTService from '@/services/cpt.service';
import PatientService from '@/services/patient.service';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('TestOrdersResultSetupL.Title'),
                    okTitle: this.$t('Shared.BtnSave'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions],
    props: {
        editMode: Boolean
    },
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                Mode: this.editMode,
                favButtonAtion: false
            },

            isReadOnly: false,
            isEditable: true,

            procTypeOptions: [
                { value: 'CHEMISTRY', name: this.$t('Shared.Chemistry') },
                {
                    value: 'COAGULATION',
                    name: this.$t('Shared.Coagulation')
                },
                { value: 'HEMATOLOGY', name: this.$t('Shared.Hematology') },
                { value: 'IMAGING', name: this.$t('Shared.Imaging') },
                { value: 'SURGICAL', name: this.$t('Shared.Surgical') }
            ],
            objecResultObj: {
                code: '',
                name: '',
                loincCode: '',
                procType: '',
                lowRange: null,
                highRange: null,
                unit: '',
                cptcode: '',
                diagCode: '',
                rxNorm: '',
                longName: '',
                unitPrice: null
            },
            ddiag: '',
            dcpt: '',
            ParamList: [
                {
                    code: 1,
                    description: this.$t('Shared.AllDiagnoses'),
                    resource: 'DiagnosisICD10Providers?'
                },
                {
                    code: 2,
                    description: this.$t('Shared.MostDiagnosesUsed'),
                    resource: 'DiagnosisICD10Providers?mustUsed=true'
                }
            ],
            modelFilter: {
                code: 1,
                description: this.$t('Shared.AllDiagnoses'),
                resource: 'DiagnosisICD10Providers'
            }
        };
    },

    methods: {
        onCodeConditionOk(result) {
            var type = result.FieldName;
            if (type.indexOf('cpt') >= 0) {
                this.dcpt = result.description;
                this.objecResultObj.cptcode = result.code;
            } else if (type.indexOf('Diagnosis') >= 0) {
                this.ddiag = result.description;
                this.objecResultObj.diagCode = result.code;
            }
        },

        getAllDescription() {
            if (this.objecResultObj.cptcode) {
                const CptParam = {
                    code: this.objecResultObj.cptcode
                };
                CPTService.getCPTByCode(CptParam)
                    .then(response => {
                        if (response.status == '200' && response.data.length > 0) {
                            this.dcpt = response.data[0].name;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
            if (this.objecResultObj.diagCode) {
                PatientService.getDiagnosis(this.objecResultObj.diagCode)
                    .then(response => {
                        if (response.status == '200' && response.data && response.data.length > 0) {
                            this.ddiag = response.data[0].name;
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        ChangeType(value) {
            this.objecResultObj.procType = value ? value.value : null;
        },

        goBack() {
            this.$router.push({ name: 'TestOrdersResultSetupListing' });
        },

        SaveOrEdit() {
            if (!this.isReadOnly) {
                elemSaveBtn.setAttribute('disabled', '');

                if (this.editMode) {
                    this.update();
                } else {
                    this.save();
                }
            }
        },

        save() {
            TestOrderResultSetupService.add(this.objecResultObj)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(
                                    this.$t('Shared.SavedSuccessfully'),
                                    {
                                        title: this.$t('Msg.Success'),
                                        autoHideDelay: 5000,
                                        variant: 'success'
                                    }
                                ),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        update() {
            TestOrderResultSetupService.update(this.$route.params.id, this.objecResultObj)
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        setTimeout(
                            () =>
                                this.$bvToast.toast(
                                    this.$t('Shared.SavedSuccessfully'),
                                    {
                                        title: this.$t('Msg.Success'),
                                        autoHideDelay: 5000,
                                        variant: 'success'
                                    }
                                ),
                            50
                        );

                        this.goBack();
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        getTestOrderResult() {
            if (this.editMode) {
                TestOrderResultSetupService.get(this.$route.params.id)
                    .then(response => {
                        if (response.status == '200' && response.data) {
                            this.objecResultObj = response.data;
                            this.getAllDescription();
                        }
                    })
                    .catch(error => {
                        this.showResponseErrorMessage(error);
                    });
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        }
    },

    async mounted() {
        this.getTestOrderResult();
        setTimeout(
            function() {
                elemSaveBtn = document.getElementById('btn_save_inventory_item');
                elemSaveBtn.setAttribute('disabled', '');
            },
            50,
            this
        );
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        EventBus.$on(
            'onChanged',
            function(e) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }.bind(this)
        );

        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
    }
};
</script>
